// src/modules/HymnSearchBar.jsx
import React, { useEffect, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

/**
 * Debounced Search Bar — Material Design
 * Props:
 *  - value (string)
 *  - onChange (function)
 *  - placeholder (string)
 *  - fullWidth (bool)
 */
export default function HymnSearchBar({ value, onChange, placeholder, fullWidth }) {
  const [local, setLocal] = useState(value || "");

  useEffect(() => setLocal(value || ""), [value]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) onChange(local);
    }, 300);
    return () => clearTimeout(t);
  }, [local]);

  return (
    <TextField
      size="small"
      variant="outlined"
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      placeholder={placeholder || "Search hymns..."}
      fullWidth={!!fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ opacity: 0.6 }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
